$(document).ready(function() {
  hideAvailabilityFacets()
});


//document.addEventListener("facet:update", async (event) => {
//  onSoftReload();
//});

window.afterSoftReload = function() {
    infiniteScrollURLTrigger();   // we need to refresh scrolling filtering, but only after first page reload
    hideAvailabilityFacets();
    resetNextPositionAndLinkIndex();
}

//function onSoftReload() { // as soon as soft reload triggers
//}

// Function to hide elements based on caption
function hideAvailabilityFacets() {
    $('.text-subdued').each(function() {
        if ($(this).text().trim() === "Availability: In stock") {
            $(this).parent().addClass('hidden'); // Hide parent element
        }
    });

    $('.text-with-icon').each(function() {
        if ($(this).text().trim() === "Availability")  {
            $(this).parent().addClass('hidden'); // Hide parent element
        }

        if ($(this).text().trim() === "Shop Tops By Size")  {
            $(this).parent().addClass('hidden'); // Hide parent element
        }

        if ($(this).text().trim() === "Shop Bottoms By Size")  {
            $(this).parent().addClass('hidden'); // Hide parent element
        }

        const pattern = /^https:\/\/www\.sartoriale\.com(\/[^\/]+)?\/collections\/coats-jackets.*$/; // https://www.sartoriale.com/*/collections/coats-jackets*  {*} is optional text, the url can be filled with anything there, so it fits filters and locales
        if ($(this).text().trim() === "SUBCATEGORY" && !(pattern.test(window.location.href))) {
            $(this).closest('summary').parent().parent().addClass('hidden'); // Hide parent element
        }

        if ($(this).text().trim() === 'PRODUCT TYPE') { //hiding every filter group that has less than 2 options
            const count = $(this)
                .closest('details')
                .find('.checkbox-control')
                .length;

            if (count <= 1) {
                $(this).closest('details').parent().addClass('hidden');
            }
        }
    });
    /// Decrease the Filter (n) text on filter selector in phone layout so it wont count the basic "in-stock" filter
    $(".collection-toolbar__button").each(function() {
        var regex = /^Filter \((.*)\)$/;  // Regular expression to match "Filters (n)" where n is a number
        var text = $(this).text().trim(); // Get the text content and trim whitespace
        var match = text.match(regex)
        if (match) {
            var originalNumber = parseInt(match[1], 10); // Convert the captured number to an integer
            var newNumber = Math.max(0, originalNumber - 1); // Decrement the number by one, ensuring it's not 
            if (newNumber > 0) {
                var newText = `Filter (${newNumber})`; // Create the new text
            } else {
                var newText = `Filter`; // Create the new text without number
            }
            $(this).text(newText); // Update the element's text
        }
    });
}
